<template>
  <div class="main">
    <app-header></app-header>
    <success-content></success-content>
  </div>
</template>

<script>
  import AppHeader from "../components/auth/AppHeader.vue";
  import SuccessContent from "../components/auth/SuccessContent.vue";
  export default {
    components: {
      SuccessContent,
      AppHeader
    },
    metaInfo() {
      return { title: this.$t("titles.auth") }
    }
  };
</script>

<style lang="scss" scoped></style>
